import * as Yup from "yup";

// ObjectId regex pattern (24 hex characters)
const objectIdRegex = /^[0-9a-fA-F]{24}$/;

export const purchaseCreateSchema = Yup.object().shape({
  billNumber: Yup.string()
    .trim()
    .min(1, "Bill number must have at least 1 character.")
    .max(100, "Bill number must have at most 100 characters.")
    .required("Bill number is required."),

  purchaseDate: Yup.date().nullable(),
});

export const purchaseUpdateSchema = Yup.object().shape({
  items: Yup.array()
    .of(
      Yup.object().shape({
        item: Yup.string()
          .required("Item ID is required.")
          .matches(
            objectIdRegex,
            "Item ID must be a valid 24-character hex ObjectId.",
          ),
        quantity: Yup.number()
          .required("Quantity is required.")
          .integer("Quantity must be an integer.")
          .min(1, "Quantity must be at least 1.")
          .default(1),
      }),
    )
    .min(1, "At least one item is required."),

  billNumber: Yup.string()
    .trim()
    .min(1, "Bill number must have at least 1 character.")
    .max(100, "Bill number must have at most 100 characters."),
});